import { render, staticRenderFns } from "./Curriculum_list.vue?vue&type=template&id=2b0be4b0&scoped=true"
import script from "./Curriculum_list.vue?vue&type=script&lang=js"
export * from "./Curriculum_list.vue?vue&type=script&lang=js"
import style0 from "./Curriculum_list.vue?vue&type=style&index=0&id=2b0be4b0&prod&scoped=true&lang=css"
import style1 from "./Curriculum_list.vue?vue&type=style&index=1&id=2b0be4b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0be4b0",
  null
  
)

export default component.exports